import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import DeckCollectionHelper from './DeckCollectionHelper'

const FlyoutCollectionStatus = ({ deckCards, deckSlug, priceSource }) => (
	<StyledToolbarFlyout>
		<DeckCollectionHelper
			flyout
			type="collection"
			deckCards={deckCards}
			deckSlug={deckSlug}
			priceSource={priceSource}
		/>
	</StyledToolbarFlyout>
)

FlyoutCollectionStatus.propTypes = {
	deckCards: PropTypes.array.isRequired,
	deckSlug: PropTypes.string.isRequired,
	priceSource: PropTypes.number.isRequired
}

const StyledToolbarFlyout = styled.div`
	padding: 0;
`

export default FlyoutCollectionStatus
